<template>
  <div class="card-sub-title-warp" @click="onClickCardTitleMore()">
    <van-row type="flex" justify="space-between" style="align-items: center">
      <van-col class="card-sub-title-name">
        <span>{{ title }}</span>
        <span v-if="reviewTime" class="review-time">{{ time }}</span>
      </van-col>
      <van-col v-if="isSubMore" class="card-sub-title-more"
        >更多<i class="iconfont ic-arrow-right-o"
      /></van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'CardSubTitle',
  components: {},
  props: {
    title: {
      type: String, // 副标题
      default: '副标题'
    },
    reviewTime: {
      type: Number, // 时间
      default: () => null
    },
    isSubMore: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    time() {
      return this.$moment(this.reviewTime * 1000).format('YYYY-MM-DD');
    }
  },
  created() {},
  mounted() {},
  methods: {
    onClickCardTitleMore() {
      // this.$emit('onClickSubTitleMore');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../common/css/common-mixin";
.card-sub-title {
  &-warp {
    // height: rpx(40);
    padding: rpx(24) 0 0;
    line-height: rpx(40);
  }
  &-name {
    height: rpx(40);
    display: flex;
    font-size: rpx(28);
    color: rgba(0, 0, 0, 0.9);
    font-weight: bold;
    .review-time {
      height: rpx(28);
      padding: 0 rpx(6);
      margin: rpx(9) 0 0 rpx(8);
      font-size: 20px;
      color: #1a66ff;
      line-height: rpx(28);
      font-weight: normal;
      border-radius: rpx(4);
      background: rgba(26, 102, 255, 0.04);
    }
  }
  &-more {
    height: rpx(45);
    font-size: rpx(24);
    color: rgba(0, 0, 0, 0.6);
    font-weight: normal;

    i {
      font-size: rpx(24);
      color: rgba(0, 0, 0, 0.4);
      margin-left: rpx(4);
      vertical-align: baseline;
    }
  }
}
</style>
